import React from 'react';
import { useNavigate } from 'react-router-dom';

import './NotAuthorized.css';

const handleLogout = ( navigate ) => {
  localStorage.removeItem('permissions');
  console.clear();
  navigate('/');
};

const NotAuthorized = () => {
  const navigate = useNavigate()

  return (
    <div className="not-authorized">
      <h1>Not Authorized</h1>
      <p>Either your permissions changed or you do not have permission to view this page.</p>
      <p>Please login again below:</p>
      <button type="button" className="login-btn" onClick={() => handleLogout(navigate)}>
        Back to login
      </button>
    </div>
  );
};



export default NotAuthorized;
